import { MapPin, Navigation2, Phone } from "lucide-react";
import { CONTACT } from "@/lib/site";

export default function Location() {
  const embedSrc =
    "https://www.google.com/maps?q=" +
    encodeURIComponent("Kalabagh Road, Nathia Gali, Pakistan") +
    "&output=embed";
  const dirHref =
    "https://www.google.com/maps/dir/?api=1&destination=" +
    encodeURIComponent("Kalabagh Road, Nathia Gali, Pakistan");

  return (
    <section
      id="location"
      data-testid="location-section"
      className="relative bg-[color:var(--sh-forest-deep)] py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 grid lg:grid-cols-12 gap-10 items-stretch">
        <div className="lg:col-span-5 flex flex-col sh-reveal">
          <div className="text-xs uppercase tracking-[0.35em] text-[color:var(--sh-amber)] mb-4">
            Location
          </div>
          <h2 className="sh-display text-[color:var(--sh-cream)] text-4xl sm:text-5xl lg:text-6xl font-medium">
            Above the mist line, right off Kalabagh Road.
          </h2>
          <div className="mt-8 space-y-5 text-[color:var(--sh-cream-dim)]">
            <div className="flex items-start gap-3">
              <MapPin size={18} className="text-[color:var(--sh-amber)] mt-1" strokeWidth={1.5} />
              <div className="text-[color:var(--sh-cream)]">
                <div className="sh-serif text-lg">Sardar House</div>
                <div className="text-sm text-[color:var(--sh-cream-dim)]">{CONTACT.address}</div>
              </div>
            </div>
            <p className="text-sm leading-relaxed max-w-md">
              About a 4-hour drive from Islamabad via the Murree–Nathia Gali road.
              Follow signs for Kalabagh; we’re just past the pine bend on the ridge side —
              call ahead and we’ll guide you in the last few turns.
            </p>
          </div>
          <div className="mt-8 flex flex-wrap gap-3">
            <a
              href={dirHref}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="location-directions-btn"
              className="sh-amber-btn inline-flex items-center gap-2 px-6 py-3 text-sm"
            >
              <Navigation2 size={15} strokeWidth={1.6} />
              Get Directions
            </a>
            <a
              href={`tel:${CONTACT.phoneRaw}`}
              data-testid="location-call-btn"
              className="sh-ghost-btn inline-flex items-center gap-2 px-6 py-3 text-sm"
            >
              <Phone size={15} strokeWidth={1.6} />
              {CONTACT.phone}
            </a>
          </div>
        </div>

        {/* Map */}
        <div className="lg:col-span-7 sh-reveal">
          <div
            data-testid="location-map"
            className="sh-map-frame relative w-full aspect-[4/3] lg:aspect-auto lg:h-full min-h-[380px] rounded-3xl overflow-hidden border border-[color:var(--sh-line)]"
          >
            <iframe
              title="Sardar House on Google Maps"
              src={embedSrc}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
            <div className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-[color:var(--sh-line)] rounded-3xl" />
          </div>
        </div>
      </div>
    </section>
  );
}
